export const workspaces_feature_flags_defaults_object = {
    enable_tag_with_market_12_months_limit_ff: false,
    enable_starred_report_box_ff: false,
    enable_menu_settings_wcag_ff: false,
    enable_company_logo_name_in_my_zone: false,
    enable_my_properties_add_remove: false,
    enable_my_properties_landing: false,
    enable_my_zone_portfolio: false,
    enable_market_tag_as_chain_ff: false,
    Additional_dates_in_tags_portfolio: false,
    enable_xtra_requests_admin_view_ff: false,
    enable_markets_in_tags_ff: false,
    enable_support_page_ff: false,
    enable_resolver_replace_csv_ff: false,
    enable_resolver_run_automation_ff: false,
    enable_submit_feedback_resolver: false,
    dev_enable_submit_sf_tickets_ff: false,
    enable_support_data_validation_nearby_reason_ff: false,
    enable_support_delivery_eta_ff: false,
    enable_support_diff_url_ff: false,
    enable_support_request_reason_for_nearby: false,
    enable_support_request_sensitive_location: false,
    enable_support_request_not_my_property: false,
    enable_support_request_update_entity_name: false,
    enable_support_request_update_entity_address: false,
    enable_files_suggest_an_edit: false,
    enable_poi_upload_save_as_tag: false,
    enable_limit_add_to_tag_ff: false,
    enable_suggest_edit_market_request_ff: false,
    enable_market_dates_limitation_in_tags_ff: false,
    enable_request_properties_sales_flow_ff: false,
    enable_add_chain_locations_tag_ff: false,
    enable_tf_error_outside_usa: false,
    enable_sqft_suggest_an_edit: false,
    enable_new_message_properties_request_ff: false,
    enable_submit_feedback_resolver_other_options_ff: false,
    enable_accessibility_mode_settings_ff: false,
    enable_accessibility_maps_mode_settings_ff: false,
    enable_coordinates_merge_ff: false,

    /** region - New Page Design FFs: */
    enable_account_settings_menu_wcag_ff: false,
    accessibility_starred_reports_ff: false,
    enable_new_custom_poi_page_ff: false,
    enable_new_traffic_pin_page_ff: false,
    enable_new_my_requests_page_ff: false,
    enable_new_my_tags_page_ff: false,
    enable_new_portfolio_page_ff: false,
    enable_new_tenant_page_ff: false,
    enable_new_my_zone_side_menu_ff: false,
    enable_new_star_page_ff: false,
    accessibility_add_properties_ff: false,
    enable_new_xtra_page_ff: false,
    enable_new_groups_edit_page_ff: false,
    accessibility_metrics_selector_ff: false,
    /** endregion - END New Page Design FFs */

    /** region - Mobile FFs: */
    disable_upgrade_message_freemium_mobile_ff: false,
    enable_ipads_on_app_ff: false,
    enable_ipad_web_app_ff: false,
    enable_visitor_journey_mobile_ff: false,
    enable_share_url_mobile_ff: false,
    disable_region_mobile_ff: false,
    disable_mobile_wcag_package_ff: false,
    /** endregion - END Mobile FFs */

    /** region - Deprecated FFs: */
    enable_traffic_pin_requests_new: false,
    enable_region_requests_new: false,
    enable_chain_requests_new: false,
    enable_property_requests_new: false,
    enable_internal_support_modals: false,
    enable_ask_support_new: false,
    /** endregion - END Deprecated FFs */

    /** region - RequestLocations service migration: */
    dev_call_request_locations_service_on_order_creation: false,
    /** endregion - END RequestLocations service migration */
};
